// extracted by mini-css-extract-plugin
export default {"container":"CountersRoot_container__9Oq02"};